var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgJson = function SvgJson(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E3F609",
    d: "M5.333 2A1.333 1.333 0 0 0 4 3.333V6a1.333 1.333 0 0 1-1.333 1.333H2v1.334h.667A1.333 1.333 0 0 1 4 10v2.667A1.333 1.333 0 0 0 5.333 14h1.334v-1.333H5.333V9.333A1.333 1.333 0 0 0 4 8a1.333 1.333 0 0 0 1.333-1.333V3.333h1.334V2zm5.334 0A1.333 1.333 0 0 1 12 3.333V6a1.334 1.334 0 0 0 1.333 1.333H14v1.334h-.667A1.333 1.333 0 0 0 12 10v2.667A1.334 1.334 0 0 1 10.667 14H9.333v-1.333h1.334V9.333A1.333 1.333 0 0 1 12 8a1.333 1.333 0 0 1-1.333-1.333V3.333H9.333V2z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgJson);
export { ForwardRef as ReactComponent };